<div class="login-container">
  <div class="login-panel">
    <div class="card">
      <!-- Login title -->
      <div class="card-header">
        <h5 class="login-title">
          <b>{{ loginTitle ? loginTitle : "ArsonData Metering" }}</b>
        </h5>
      </div>

      <!-- Login logo -->
      <span class="logo-lg d-flex">
        <img class="img-fluid center" src="{{ logoUrl ? logoUrl : defaultImg }}" alt="Login Logo" />
      </span>

      <!-- Login form -->
      <div class="card-body">
        <form
          id="login-form"
          (ngSubmit)="!loginWating && loginBlockedTime === 0 && (authenticatorRequired ? SubmitLogin2fa() : loginFirst())"
        >
          <!-- User -->
          <div class="form-group has-feedback">
            <input
              [(ngModel)]="username"
              name="username"
              class="form-control"
              placeholder="{{ 'user' | translate }}..."
              [disabled]="
                loginWating || loginBlockedTime > 0 || authenticatorRequired
              "
              autocomplete="username"
            />
            <i class="fas fa-user form-control-feedback"></i>
          </div>

          <!-- Password -->
          <div class="form-group has-feedback">
            <input
              [(ngModel)]="password"
              [type]="hidePassword ? 'password' : 'text'"
              name="password"
              class="form-control"
              placeholder="{{ 'password' | translate }}..."
              [disabled]="
                loginWating || loginBlockedTime > 0 || authenticatorRequired
              "
              autocomplete="current-password"
            />
            <i
              class="form-control-feedback pointer"
              [ngClass]="hidePassword ? 'fas fa-lock' : 'fas fa-unlock'"
              title="{{ 'show' | translate }}"
              (click)="hidePassword = !hidePassword"
            ></i>
          </div>
        </form>

        <!-- MFA Method Selection -->
        @if (authenticatorRequired && !methodAccepted && mailRegistered) {
          <div class="login-mfa-selection">
            <h5 class="mb-3 d-flex justify-content-center align-items-center">
              <i class="fas fa-key me-2"></i>
              <b>{{ "select-mfa-method" | translate }}</b>
            </h5>
            <!-- Authenticator -->
            <button
              mat-button
              class="mat-button-icon-text"
              (click)="authMethod = 'app';confirmMFAMethod()"
            >
              <img
                src="../../../../assets/img/login/Google_Authenticator.png"
                alt="Google Authenticator"
                width="20"
                height="20"
              />
              {{ "code" | translate }}
            </button>
            <!-- e-mail -->
            <button
              mat-button
              class="mat-button-icon-text"
              (click)="authMethod = 'email';confirmMFAMethod()"
            >
              <i class="fas fa-envelope" style="width: 20px;"></i>
              {{ "mail" | translate }}
            </button>
          </div>
        }

        <!-- Authenticator -->
        @if (authenticatorRequired && methodAccepted && authMethod === 'app') {
          <div class="form-group has-feedback">
            <div class="google-authenticator-code">
              @if (authenticatorQr) {
                <img [src]="authenticatorQr" alt="Authenticator QR" />
              }
              <input
                #authenticationKeyInput
                [(ngModel)]="authenticatorKey"
                name="text"
                class="form-control authenticator-input"
                placeholder="{{ 'code' | translate }}..."
                autocomplete="off"
                (keyup.enter)="SubmitLogin2fa()"
              />
              @if (authenticatorQr) {
                <span>
                  {{
              "login-authenticator-qr-help" | translate
                  }}
                </span>
              }
              @if (!authenticatorQr) {
                <span>
                  {{
              "login-authenticator-help" | translate
                  }}
                </span>
              }
            </div>
          </div>
        }

        <!-- Email Authenticator -->
        @if (authenticatorRequired && methodAccepted && authMethod === 'email') {
          <div class="form-group has-feedback">
            <div class="google-authenticator-code">
              <input
                #emailAuthCodeInput
                [(ngModel)]="emailAuthCode"
                name="text"
                class="form-control mail-input"
                placeholder="{{ 'code' | translate }}..."
                autocomplete="off"
                (keyup.enter)="SubmitLogin2fa()"
              />
              @if (!codeEmailSent) {
                <span>
                  {{
              "login-authenticator-email-help" | translate
                  }}
                </span>
              }
              @if (codeEmailSent) {
                <span class="text-success">
                  {{
              "login-authenticator-email-sent" | translate
                  }}
                </span>
              }
              <button
                class="btn btn-secondary btn-sm mt-2"
                [disabled]="resendCooldown > 0"
                (click)="onResendCode()"
              >
                {{ resendCooldown > 0 ? ('resend-wait' | translate:{seconds: resendCooldown}) : ('resend-code' |
            translate) }}
              </button>
            </div>
          </div>
        }

        <!-- Submit -->
        @if (!authenticatorRequired || methodAccepted) {
          <div class="form-group">
            <button
              type="submit"
              form="login-form"
              name="enter"
              [disabled]="loginWating || loginBlockedTime > 0"
              class="btn btn-primary btn-block"
            >
              @if (loginWating && loginAttemps == 0) {
                <div class="fa-stack fa-4x hourglass-spin">
                  <i class="fa fa-stack-1x fa-hourglass-start"></i>
                  <i class="fa fa-stack-1x fa-hourglass-half"></i>
                  <i class="fa fa-stack-1x fa-hourglass-end"></i>
                  <i class="fa fa-stack-1x fa-hourglass-end spin"></i>
                </div>
              }
              {{
          loginBlockedTime > 0
          ? loginBlockedTime + " s"
          : ("enter" | translate)
              }}
            </button>
          </div>
        }

        @if (authenticatorRequired && methodAccepted && authenticatorQr && authMethod === 'app') {
          <div class="google-authenticator-download">
            <div>
              <img
                src="../../../../assets/img/login/Google_Authenticator.png"
                alt="Google Authenticator Logo"
              />
              <span>Google Authenticator</span>
            </div>
            <span>{{ "login-authenticator-download-help" | translate }}</span>
            <div class="google-authenticator-download-qr">
              <div class="pointer" [ngClass]="{ 'icon-off': showIosLink }">
                <span (click)="showIosLink = false; showAndroidLink = true">
                  <img src="../../../../assets/img/login/android.png" alt="Android Logo" />
                </span>
              </div>
              <div class="pointer" [ngClass]="{ 'icon-off': showAndroidLink }">
                <span (click)="showAndroidLink = false; showIosLink = true">
                  <img src="../../../../assets/img/login/ios.png" alt="iOS Logo" />
                </span>
              </div>
            </div>
            @if (showAndroidLink) {
              <img
                src="../../../../assets/img/login/google_authenticator_android.png"
                alt="Google Authenticator Android"
              />
            }
            @if (showIosLink) {
              <img
                src="../../../../assets/img/login/google_authenticator_ios.png"
                alt="Google Authenticator iOS"
              />
            }
            <span
              class="footer-highlight pointer"
              (click)="showContact()"
              (keydown)="showContact()"
            >
              <a>{{ "contact" | translate }}</a>
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
